import { User, UserLoginOrRegistrationRequest, UserSocial } from '../../types';
import { sendUserToBackend } from './backendAuth';

// 환경변수에서 설정값 가져오기
const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO_CLIENT_ID || 'your_kakao_client_id_here';
const KAKAO_REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI || 'http://localhost:3000/auth/kakao/callback';

// Kakao SDK 초기화
export const initializeKakao = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_CLIENT_ID);
      }
      resolve();
    } else {
      reject(new Error('Kakao SDK가 로드되지 않았습니다.'));
    }
  });
};

// Kakao SDK 로드 함수
const loadKakaoSDK = async (): Promise<boolean> => {
  if (window.Kakao) {
    return true;
  }

  try {
    const kakaoScript = document.createElement('script');
    kakaoScript.src = 'https://developers.kakao.com/sdk/js/kakao.js';
    kakaoScript.async = true;
    
    await new Promise<void>((resolve, reject) => {
      kakaoScript.onload = () => resolve();
      kakaoScript.onerror = () => reject(new Error('Kakao SDK 로드 실패'));
      document.head.appendChild(kakaoScript);
    });

    // console.log('Kakao SDK 로드 성공');
    return true;
  } catch (error) {
    console.error('Kakao SDK 로드 실패:', error);
    return false;
  }
};

// 백엔드 통신 함수는 authUtils.ts에서 가져옴

// Kakao 로그인
export const kakaoLogin = async (navigate: any): Promise<UserSocial> => {
  try {
    // SDK가 로드되지 않은 경우 로드
    if (!window.Kakao) {
      const sdkLoaded = await loadKakaoSDK();
      if (!sdkLoaded) {
        throw new Error('Kakao SDK 로드에 실패했습니다.');
      }
    }
    
    await initializeKakao();
    
    return new Promise((resolve, reject) => {
      if (!window.Kakao) {
        reject(new Error('Kakao SDK가 로드되지 않았습니다.'));
        return;
      }
      
      window.Kakao.Auth.login({success: async (authObj: any) => {
            try {
              if (!window.Kakao || !window.Kakao.API) {
                reject(new Error('Kakao API가 초기화되지 않았습니다.'));
                return;
              }
              
              window.Kakao.API.request({
                url: '/v2/user/me',
                success: async (userObj: any) => {
                // console.log('kakao', userObj, '/[kakao profile ------------------------------>]');

                //카카오 로그인 의 경우, 전화번호와 약관동의를 받는다고 가정한다.
                const agree_privacy_policy = true;
                const agree_terms_of_service = true;
                const agree_marketing_information = false;

                const phone_number = userObj.kakao_account?.phone_number || null;
                const phone_number_verified = phone_number !== null;

                let socialUser: UserSocial = {
                  id: `${userObj.id}`,
                  name: userObj.kakao_account?.name || userObj.kakao_account?.profile?.nickname || '카카오 사용자',
                  email: userObj.kakao_account?.email || '',
                  phone_number: phone_number,
                  picture: userObj.kakao_account?.profile?.profile_image_url || '',
                  provider: 'kakao',
                  accessToken: authObj.access_token,
                };

                const userLoginOrRegistrationRequest: UserLoginOrRegistrationRequest = {
                  agree_privacy_policy: agree_privacy_policy,
                  agree_terms_of_service: agree_terms_of_service,
                  agree_marketing_information: agree_marketing_information,
                  phone_number_verified: phone_number_verified,
                  ...socialUser,
                };

                // console.log("로그인 폼 전송", userLoginOrRegistrationRequest, '/[userLoginOrRegistrationRequest------------------------------>]');

                // 백엔드에 사용자 정보 전송
                const data = await sendUserToBackend(userLoginOrRegistrationRequest);

                if (data.success === false) {
                  if ( data?.id !== undefined && data?.id !== null && data?.id !== '' ) {
                    localStorage.setItem('kuid', data.id);

                    if (!data?.agree_terms_of_service || !data?.agree_privacy_policy) {
                      // 약관 동의가 필요한 경우 회원가입 플로우로 리다이렉트
                      navigate('/join',{state:{social_provider:`kakao`, user:data}});
                      return;
                    }
        
                    if (!data.phone_number_verified) {
                      // 전화번호 인증이 필요한 경우 전화번호 인증 플로우로 리다이렉트
                      const url = `/phone-verification?kuid=${data.id}`;
                      navigate(url);
                      return;
                    }
                  }
    
                  // 로그인 실패
                  console.log(data,'/[googleLogin googleLogin reject------------------------------>]');
                  reject(new Error(data.message || '로그인(또는 사용자등록)에 실패했습니다.'));
                  return;
                } else {
                  // 로그인 성공
                  resolve(data);
                }
              },
              fail: (error: any) => {
                reject(new Error('카카오 사용자 정보 조회 실패: ' + error));
              }
            });
          } catch (error) {
            reject(error);
          }
        },
        fail: (error: any) => {
          reject(new Error('카카오 로그인 실패: ' + error));
        }
      });
    });
  } catch (error) {
    throw new Error('카카오 로그인 초기화 실패: ' + error);
  }
};
